module.exports = __webpack_public_path__ + "static/media/diktat-13.5290fc39.mp3";